import { cardImageSources, type GenericCharacter } from './types'

export const genericFantasma: GenericCharacter = {
  id: 'generic-fantasma',
  enabled: true,
  order: 4,
  displayName: 'Bruma',
  icon: '👻',
  imageSources: cardImageSources('generic-fantasma'),
  previewVideoSrc: '/videos/previews/generic-fantasma.mp4',
}
